export const DEPARTMENT_NOT_ASSIGNED = 'GENERAL.NOT_ASSIGNED';
export const NO_RESELLER = 'No reseller';
